import styled from "styled-components";

export const WidgetContainer = styled.div`
  margin-top: 16px;
`;
